
import { Component, Vue, Prop } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { addFaultCode } from "@/api/api-basic";
import regular from "@/common/regular";
import i18n from "@/config/i18n";
@Component({
  components: {}
})
export default class PiAddFile extends Vue {
  @Prop({
    default: () => {
      return [];
    }
  })
  private gradeList!: objAny[];
  @Prop({
    default: () => {
      return [];
    }
  })
  private typeList!: objAny[];
  private formInline: objAny = {
    formList: []
  };
  private formInlineJson: objAny = {
    faultCode: "",
    faultName: "",
    faultEnName: "",
    faultTipMsg: "",
    faultTipEnMsg: "",
    solution: "",
    alarmLevel: "",
    alarmType: ""
  };
  private upgradeTime = "";
  private loading = false;
  private modalShow = false;
  private modalTitle = i18n.t("alarmSet.add");
  private formObj: objAny = {};
  private ruleInline: objAny = {
    faultCode: [
      {
        required: true,
        name: i18n.t("alarmSet.faultCode"),
        trigger: "blur",
        validator: regular.int
      }
    ],
    faultName: [
      {
        required: true,
        message: i18n.t("alarmSet.faultNamePl"),
        trigger: "blur"
      }
    ],
    faultEnName: [
      {
        required: true,
        message: i18n.t("alarmSet.faultEnNamePl"),
        trigger: "blur"
      }
    ],
    faultTipMsg: [
      {
        required: true,
        message: i18n.t("alarmSet.faultTipMsgPl"),
        trigger: "blur"
      }
    ],
    faultTipEnMsg: [
      {
        required: true,
        message: i18n.t("alarmSet.faultTipEnMsgPl"),
        trigger: "blur"
      }
    ],
    // solution: [{ required: true, message: "请输入解决方法", trigger: "blur" }],
    alarmLevel: [
      {
        required: true,
        message: i18n.t("alarmSet.alarmLevelPl"),
        trigger: "change"
        // type: "number"
      }
    ],
    alarmType: [
      {
        required: true,
        message: i18n.t("alarmSet.alarmTypePl"),
        trigger: "change"
        // type: "number"
      }
    ]
  };
  private isAdd = false;
  private faultCode = "";
  public open() {
    this.$nextTick(() => {
      this.formObj = this.$refs["formInline"];
    });
    this.modalShow = true;
    this.formInline.formList = [];
    this.addRow();
  }
  public addRow() {
    const formInlineJson: objAny = JSON.parse(
      JSON.stringify(this.formInlineJson)
    );
    this.formInline.formList.push(formInlineJson);
  }
  public removeRow(index: number) {
    this.formInline.formList.splice(index, 1);
  }
  public handleSubmit() {
    this.formObj.validate((valid: boolean) => {
      if (valid) {
        this.submitData();
      }
    });
  }
  async submitData(): Promise<void> {
    this.loading = true;
    const ret = await addFaultCode({ params: this.formInline.formList });
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("addSuccess"));
      this.$emit("success");
      this.modalShow = false;
    }
    this.loading = false;
  }
}
